import PedidoItemDetMetragemService from "@/services/PedidoItemDetMetragemService";

export const pedidoItemDetMetragem = {
  namespaced: true,
  state: {
    pedidoItemDetMetragem: {},
  },
  actions: {
    getPedidoItemDetMetragem({ commit }, payload) {
      return PedidoItemDetMetragemService.GetPedidoItemDetMetragem(
        payload
      ).then(
        (pedidoItemDetMetragem) => {
          return Promise.resolve(pedidoItemDetMetragem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoItemDetMetragem({ commit }, payload) {
      return PedidoItemDetMetragemService.PostPedidoItemDetMetragem(
        payload
      ).then(
        (pedidoItemDetMetragem) => {
          return Promise.resolve(pedidoItemDetMetragem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoItemDetMetragem({ commit }, payload) {
      return PedidoItemDetMetragemService.PutPedidoItemDetMetragem(
        payload
      ).then(
        (pedidoItemDetMetragem) => {
          return Promise.resolve(pedidoItemDetMetragem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoItemDetMetragem({ commit }, payload) {
      return PedidoItemDetMetragemService.DeletePedidoItemDetMetragem(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoItemDetMetragemOData({ commit }, payload) {
      return PedidoItemDetMetragemService.GetPedidoItemDetMetragemOData(
        payload
      ).then(
        (pedidoItemDetMetragem) => {
          return Promise.resolve(pedidoItemDetMetragem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoItemDetMetragem;
